import { render, staticRenderFns } from "./tuikuan.vue?vue&type=template&id=4231b5bf"
import script from "./tuikuan.vue?vue&type=script&lang=js"
export * from "./tuikuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports